export default {
    setShowCar(state, e) {
        state.showCar = e
    },
    setAddress(state, e) {
        state.default = e
    },
    setGoodsId(state, e) {
        state.goodsId = e
    },
    setistab(state, e) {
        state.istab = e
    },
    SETORDER(state, e) {
        state.orderInfo = e
    },
    SETADDRESS(state, e) {
        state.isAddress = e
    },
    SETMODULE(state, e) {
        state.isAdd = e
    },
    SETADDRESSINFO(state, e) {
        state.addrsesInfo = e
    }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js